export interface CommentNotificationState {
    [idSolicitation: number]: {
        visible: boolean,
        oldAmountOfComments: number;
        numberOfComments: number;
        sumarization: boolean
        reloadSumary: boolean
    };
}

const initialNotificationState: CommentNotificationState = {};

type Action = { type: string, payload: any };

export const commentNotificationReducer = (state: CommentNotificationState = initialNotificationState, action: Action) => {
    switch(action.type) {
        case "ShowNotification":
            return {
                ...state,
                [action.payload.idSolicitation]: {
                    ...state[action.payload.idSolicitation],
                    ...action.payload
                }
            };
        case "HideNotification":
            const { idSolicitation, oldAmountOfComments, sumarization, reloadSumary } = action.payload;
            return {
                ...state,
                [idSolicitation]: {
                    ...state[idSolicitation],
                    visible: false,
                    oldAmountOfComments,
                    sumarization,
                    reloadSumary
                }
            };
        default:
            return state;
    }
};
